// v10/src/hooks/useIsMobile.js
// Breakpoint de "teléfono" para grids, paddings y tipografía de las tabs.
// NO confundir con el breakpoint del shell (lg = 1024), que controla sidebar-vs-header.

import { useState, useEffect } from 'react';

const useIsMobile = (breakpoint = 640) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  );
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, [breakpoint]);
  return isMobile;
};

export default useIsMobile;
